import { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Head } from 'vite-react-ssg'

import { SITE } from '../components/SeoHead'

/**
 * A page that used to live here and now lives somewhere else.
 *
 * Pre-rendered at the OLD path so the URL still returns HTML instead of a
 * 404. The canonical tag points crawlers at the new page; the meta refresh
 * covers no-JS clients; the effect moves live visitors immediately and
 * `replace` keeps the dead URL out of their history.
 */
export default function RedirectPage({ to }: { to: string }) {
  const navigate = useNavigate()

  useEffect(() => {
    navigate(to, { replace: true })
  }, [navigate, to])

  return (
    <div className="not-found">
      <Head>
        <title>This page moved — Chosen Help</title>
        <link rel="canonical" href={`${SITE}${to}`} />
        <meta httpEquiv="refresh" content={`0; url=${to}`} />
        <meta name="robots" content="noindex, follow" />
      </Head>
      <h1>This page moved</h1>
      <p>
        It lives at <Link to={to}>{to}</Link> now. You should land there in a
        moment — the link works if you'd rather not wait.
      </p>
    </div>
  )
}
